export const DEFAULT_LABELS = {
	sectionTitle: 'Discover Providers By Category',
	totalProviders: 'business providers'
};
